import { TABLA_SECTIONS } from "@config/SectionRoutesConstants";

export const DEFAULT_COLOR = "#7A7A7A" as string;

// Default LB1 AD background color.
export const DEFAULT_ADBG_COLOR = "#FFF5E5" as string;

export const colorConstants = {
  Community: {
    color: {
      lightBg: "#D3143F",
      darkBg: "#FF0039",
    },
  },
  News: {
    color: {
      lightBg: "#FA624B",
      darkBg: "",
    },
  },
  Lifestyle: {
    color: {
      lightBg: "#00A9AF",
      darkBg: "",
    },
  },
  Culture: {
    color: {
      lightBg: "#D766A3",
      darkBg: "",
    },
  },
};

export type SubmenuItem = {
  title: string;
  url: string;
  newTab: boolean;
};

type SectionSubmenus = {
  [section: string]: SubmenuItem[];
};

export const SUBSECTION_MENUS: SectionSubmenus =
  TABLA_SECTIONS.reduce<SectionSubmenus>(
    (menus, { title, slug, subSections }) => {
      menus[title] = [
        {
          title: "Latest",
          url: `/${slug}`,
          newTab: false,
        },
        ...subSections.map(
          ({ title: subSectionTitle, slug: subSectionSlug }) => ({
            title: subSectionTitle,
            url: `/${slug}/${subSectionSlug}`,
            newTab: false,
          }),
        ),
      ];

      return menus;
    },
    {},
  );
